import React, { Component } from 'react';
import MaterialIcon from 'material-icons-react';
import Button from '../Components/Button.js';
import './CreateRoom.css'

export default class extends Component {
  constructor(props) {
    super(props);
    let generatedRoomName = this.getRandomRoomName();
    this.state = {
      roomNameTyped: '',
      roomNamePlaceholder: generatedRoomName,
      roomName: generatedRoomName
    }

    this.handleChange = this.handleChange.bind(this);
    this.generateNewRoomName = this.generateNewRoomName.bind(this);
  }

  componentDidMount() {
    this.roomNameInput.focus();
  }

  handleChange(event) {
    let roomNameTyped = event.target.value.replace(/\s+/g, '-');
    this.setState({
      roomNameTyped: roomNameTyped,
      roomName: roomNameTyped || this.state.roomNamePlaceholder
    })
  }

  generateNewRoomName() {
    let generatedRoomName = this.getRandomRoomName();
    this.setState({
      roomNamePlaceholder: generatedRoomName,
      roomName: generatedRoomName
    })
  }

  getRandomInt(number) {
    return Math.floor(Math.random() * Math.floor(number));
  }

  getRandomRoomName() {
    let roomNames = ['prancing-pony', 'crusty-crab', 'batcave', 'hogwarts', 'war-room', 'cloverfield-lane', 'aquarium', 'pig-pen', 'bird-cage', 'grayskull', 'vault' ]
    let randomRoomName = roomNames[this.getRandomInt(roomNames.length)];
    return randomRoomName + '-' + this.getRandomInt(9999);
  }

  render() {
    let generateButton = (this.state.roomNameTyped) ? null : (<div className="generate-name" onClick={this.generateNewRoomName}><MaterialIcon icon="autorenew" /></div>);

    return (
      <div className="create-room">
        <div className="create-room-title">Create your estimating room</div>
        <div className="create-room-name">
          <label>estimato.io/</label>
          {generateButton}
          <input type="text"
            onChange={this.handleChange}
            value={this.state.roomNameTyped}
            placeholder={this.state.roomNamePlaceholder}
            ref={(input) => { this.roomNameInput = input; }} />
        </div>
        <a href={`/${this.state.roomName}`}>
          <Button className="button--green button--full">Create new room</Button>
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Entry/CreateRoom.js